"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var react_intl_1 = require("react-intl");
var ToolTip_1 = __importDefault(require("../../../../../../packages/ui-shared-lite/ToolTip"));
var utils_1 = require("../utils");
var VoiceRecorder_1 = __importDefault(require("./VoiceRecorder"));
var ENTER_CHAR_CODE = 13;
var Composer = /** @class */ (function (_super) {
    __extends(Composer, _super);
    function Composer(props) {
        var _this = _super.call(this, props) || this;
        _this.focus = function () {
            setTimeout(function () {
                var _a;
                (_a = _this.textInput.current) === null || _a === void 0 ? void 0 : _a.focus();
            }, 50);
        };
        _this.handleKeyPress = function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.props.enableResetSessionShortcut && e.ctrlKey && e.charCode === ENTER_CHAR_CODE)) return [3 /*break*/, 3];
                        e.preventDefault();
                        return [4 /*yield*/, this.props.resetSession()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.props.sendMessage()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                    case 3:
                        if (!(e.key === 'Enter')) return [3 /*break*/, 5];
                        e.preventDefault();
                        return [4 /*yield*/, this.props.sendMessage()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.handleKeyDown = function (e) {
            if (_this.props.enableArrowNavigation) {
                var shouldFocusPrevious = e.target.selectionStart === 0 && (e.key === 'ArrowUp' || e.key === 'ArrowLeft');
                if (shouldFocusPrevious) {
                    _this.props.focusPrevious();
                }
                var shouldFocusNext = e.target.selectionStart === _this.textInput.current.value.length &&
                    (e.key === 'ArrowDown' || e.key === 'ArrowRight');
                if (shouldFocusNext) {
                    _this.props.focusNext();
                }
            }
            else if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                _this.props.recallHistory(e.key);
            }
        };
        _this.handleMessageChanged = function (e) {
            var _a = _this.props, updateMessage = _a.updateMessage, composerMaxTextLength = _a.composerMaxTextLength;
            var msg = e.target.value.slice(0, composerMaxTextLength);
            updateMessage(msg);
        };
        _this.isLastMessageFromBot = function () {
            var _a, _b, _c, _d;
            return ((_d = (_c = (_b = (_a = _this.props.currentConversation) === null || _a === void 0 ? void 0 : _a.messages) === null || _b === void 0 ? void 0 : _b.slice(-1)) === null || _c === void 0 ? void 0 : _c.pop()) === null || _d === void 0 ? void 0 : _d.authorId) === undefined;
        };
        _this.onVoiceStart = function () {
            _this.setState({ isRecording: true });
        };
        _this.onVoiceEnd = function (voice, ext) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ isRecording: false });
                        return [4 /*yield*/, this.props.sendVoiceMessage(voice, ext)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.onVoiceNotAvailable = function () {
            console.warn('Voice input is not available on this browser. Please check https://developer.mozilla.org/en-US/docs/Web/API/MediaRecorder for compatibility');
        };
        _this.textInput = react_1.default.createRef();
        _this.state = { isRecording: false };
        return _this;
    }
    Composer.prototype.componentDidMount = function () {
        var _this = this;
        this.focus();
        (0, mobx_1.observe)(this.props.focusedArea, function (focus) {
            var _a;
            focus.newValue === 'input' && ((_a = _this.textInput.current) === null || _a === void 0 ? void 0 : _a.focus());
        });
    };
    Composer.prototype.componentWillReceiveProps = function (newProps) {
        // Focus on the composer when it's unlocked
        if (this.props.composerLocked === true && newProps.composerLocked === false) {
            this.focus();
        }
    };
    Composer.prototype.render = function () {
        if (this.props.composerHidden) {
            return null;
        }
        var direction;
        if (this.props.message) {
            direction = utils_1.isRTLText.test(this.props.message) ? 'rtl' : 'ltr';
        }
        var placeholder = this.props.composerPlaceholder ||
            this.props.intl.formatMessage({
                id: this.isLastMessageFromBot() ? 'composer.placeholder' : 'composer.placeholderInit'
            }, { name: this.props.botName });
        return (react_1.default.createElement("div", { role: "region", className: (0, classnames_1.default)('bpw-composer', direction) },
            react_1.default.createElement("div", { className: 'bpw-composer-inner' },
                react_1.default.createElement("div", { className: 'bpw-composer-textarea' },
                    react_1.default.createElement("textarea", { ref: this.textInput, id: "input-message", onFocus: this.props.setFocus.bind(this, 'input'), placeholder: placeholder, onChange: this.handleMessageChanged, value: this.props.message, onKeyPress: this.handleKeyPress, onKeyDown: this.handleKeyDown, "aria-label": this.props.intl.formatMessage({
                            id: 'composer.message',
                            defaultMessage: 'Message to send'
                        }), disabled: this.props.composerLocked }),
                    react_1.default.createElement("label", { htmlFor: "input-message", style: { display: 'none' } }, placeholder)),
                react_1.default.createElement("div", { className: 'bpw-send-buttons' },
                    react_1.default.createElement(ToolTip_1.default, { childId: "btn-send", content: this.props.isEmulator
                            ? this.props.intl.formatMessage({
                                id: 'composer.interact',
                                defaultMessage: 'Interact with your chatbot'
                            })
                            : this.props.intl.formatMessage({
                                id: 'composer.sendMessage',
                                defaultMessage: 'Send Message'
                            }) },
                        react_1.default.createElement("button", { className: 'bpw-send-button', disabled: !this.props.message.length || this.props.composerLocked || this.state.isRecording, onClick: this.props.sendMessage.bind(this, undefined), "aria-label": this.props.intl.formatMessage({
                                id: 'composer.send',
                                defaultMessage: 'Send'
                            }), id: "btn-send" },
                            react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'composer.send' }))),
                    this.props.enableVoiceComposer && (react_1.default.createElement(VoiceRecorder_1.default, { onStart: this.onVoiceStart, onDone: this.onVoiceEnd, onNotAvailable: this.onVoiceNotAvailable }))))));
    };
    return Composer;
}(react_1.default.Component));
exports.default = (0, mobx_react_1.inject)(function (_a) {
    var store = _a.store;
    return ({
        enableVoiceComposer: store.config.enableVoiceComposer,
        message: store.composer.message,
        composerLocked: store.composer.locked,
        composerHidden: store.composer.hidden,
        composerPlaceholder: store.composer.composerPlaceholder,
        composerMaxTextLength: store.composer.composerMaxTextLength,
        updateMessage: store.composer.updateMessage,
        recallHistory: store.composer.recallHistory,
        intl: store.intl,
        sendMessage: store.sendMessage,
        sendVoiceMessage: store.sendVoiceMessage,
        botName: store.botName,
        setFocus: store.view.setFocus,
        focusedArea: store.view.focusedArea,
        focusPrevious: store.view.focusPrevious,
        focusNext: store.view.focusNext,
        enableArrowNavigation: store.config.enableArrowNavigation,
        enableResetSessionShortcut: store.config.enableResetSessionShortcut,
        resetSession: store.resetSession,
        currentConversation: store.currentConversation,
        isEmulator: store.isEmulator,
        preferredLanguage: store.preferredLanguage
    });
})((0, react_intl_1.injectIntl)((0, mobx_react_1.observer)(Composer)));
